import { Directive, OnInit, OnDestroy, Input, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[DestoryDirective]',
  exportAs: 'DestoryDirective',
})
export class DestoryDirective implements OnInit, OnDestroy, AfterViewInit {
  @Input() init;
  @Input() destory;
  @Input() afterViewInit;


  @Input() param1;
  @Input() param2;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    try {
      this.init(this.param1,this.param2)
    }
    catch (err) {

    }
  }

  ngAfterViewInit(): void {
    try {
      this.afterViewInit(this.el,this.param1,this.param2)
    } catch (error) {

    }
  }

  ngOnDestroy(): void {
    try {
      this.destory(this.param1,this.param2);
    }
    catch (err) {

    }
  }
}


@Directive({
  selector: '[ContextMenu]'
})
export class ContextMenuDirective {

  @Input() closeContextMenuRef;
  @Input() openContextMenuRef;
  @Input() tabDetails;
  opened = 0;

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onClick(event) {
    let targetElement = event.target as HTMLElement;
    if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
      this.opened = 0;
      this.closeContextMenuRef();
    }
    else {
      if (targetElement && this.elementRef.nativeElement.contains(targetElement) && !this.opened) {
        this.opened = 1;
        this.openContextMenuRef();
      }
    }

  }
}
@Directive({
  selector: '[ngInit]'
})
export class NgInitDirective implements OnInit {

  @Input() func;

  constructor() {

  }

  ngOnInit() {

    setTimeout(() => {
      if (this.func) {

        this.func();
      }
    }, 1000)
  }
}
